export default "__VITE_ASSET__DIgs0Uy0__"